import { styled } from '@mui/material'
import { Flex } from 'styles'

export const CancelText = styled('span')`
  color: rgba(202, 213, 220, 1);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: rgba(160, 238, 9, 1);

  &:hover {
    color: rgba(160, 238, 9, 1);
    transition: color ease-in-out 0.2s;
    cursor: pointer;
  }
`

export const TableCell = styled(Flex)`
  flex-wrap: wrap;
`

export const OpenCancel = styled('div')`
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  padding: 4px 8px;
  /* color: rgba(202, 213, 220, 1); */
  color: rgba(160, 238, 9, 1);
  border-radius: 20px;
  background-color: transparent;
  &:hover {
    /* color: rgba(207, 59, 49, 1); */
    color: rgba(160, 238, 9, 1);
    background-color: rgba(58, 80, 25, 1);
  }
`
